import { Dialog, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import React, { Fragment, useState } from "react";
import AdminPatientGeneral from "./AdminPatientGeneral";
import AdminPatientClinicalFinding from "./AdminPatientClinicalFinding";
import AdminPatientLicense from "./AdminPatientLicense";

const AdminEditDoctorPatient = ({ isOpen, closeModal, patient }) => {
  const [tab, setTab] = useState("general");

  const tabClass = (active) =>
    `flex items-center gap-2 px-5 py-2.5 font-bold text-xs rounded-xl transition duration-200 cursor-pointer ${
      active
        ? "bg-secondary text-white shadow-md shadow-indigo-900/10"
        : "text-slate-650 hover:bg-slate-50 hover:text-slate-850"
    }`;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-xs" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-2xl transition-all border border-slate-100">
                {/* Header panel */}
                <div className="flex justify-between items-center px-6 py-4 border-b border-slate-100">
                  <Dialog.Title as="h3" className="text-sm font-extrabold text-slate-800 uppercase tracking-wider flex items-center gap-2">
                    <Icon icon="solar:user-id-bold-duotone" className="text-secondary text-lg" />
                    <span>Patient Profile Management</span>
                  </Dialog.Title>
                  <button
                    onClick={closeModal}
                    className="p-1.5 border border-slate-200 hover:border-red-200 text-slate-400 hover:text-red-500 rounded-lg transition duration-150 cursor-pointer"
                  >
                    <Icon icon="solar:close-square-linear" className="text-lg" />
                  </button>
                </div>

                {/* Tab Switcher Navigation */}
                <div className="px-6 pt-4">
                  <div className="flex flex-col sm:flex-row bg-slate-100 p-1.5 rounded-2xl gap-1.5 w-full sm:w-fit">
                    <button
                      onClick={() => setTab("general")}
                      className={`${tabClass(tab === "general")} justify-center`}
                    >
                      <Icon icon={tab === "general" ? "solar:user-id-bold" : "solar:user-id-linear"} className="text-base" />
                      <span>General Settings</span>
                    </button>
                    <button
                      onClick={() => setTab("license")}
                      className={`${tabClass(tab === "license")} justify-center`}
                    >
                      <Icon icon={tab === "license" ? "solar:wallet-money-bold" : "solar:wallet-money-linear"} className="text-base" />
                      <span>License & Billing</span>
                    </button>
                    <button
                      onClick={() => setTab("clinicalFinding")}
                      className={`${tabClass(tab === "clinicalFinding")} justify-center`}
                    >
                      <Icon icon={tab === "clinicalFinding" ? "solar:document-text-bold" : "solar:document-text-linear"} className="text-base" />
                      <span>Clinical findings</span>
                    </button>
                  </div>
                </div>

                {/* Modal Dynamic Body Content */}
                <div className="p-6">
                  {tab === "general" && (
                    <AdminPatientGeneral
                      patient={patient}
                      patientId={patient?._id}
                    />
                  )}

                  {tab === "clinicalFinding" && (
                    <AdminPatientClinicalFinding patientId={patient?._id} />
                  )}

                  {tab === "license" && (
                    <AdminPatientLicense patientId={patient?._id} />
                  )}
                </div>

                {/* Footer panel */}
                <div className="bg-slate-50 px-6 py-3 flex justify-end rounded-b-2xl border-t border-slate-100">
                  <button
                    onClick={closeModal}
                    className="bg-white hover:bg-slate-50 text-slate-600 border border-slate-200 font-bold py-1.5 px-4 rounded-xl text-xs transition cursor-pointer"
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AdminEditDoctorPatient;
